export const getForumData = (state) => state.forumData || {};
export const getInstanceId = (state) => getForumData(state)._id;
export const getForumTitle = (state) => getForumData(state).label;
